import { useState, useEffect } from "react";
import { getChartDateRange } from "../utils/helper";

const useChartPeriod = (initialPeriod = "week") => {
  const [period, setPeriod] = useState(initialPeriod);
  const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" });

  useEffect(() => {
    const range = getChartDateRange(period);
    setDateRange(range);
  }, [period]);

  const handlePeriodChange = (selectedOption) => {
    setPeriod(selectedOption?.value);
  };

  return {
    period,
    setPeriod,
    dateRange,
    handlePeriodChange,
  };
};

export default useChartPeriod;
